import { render, staticRenderFns } from "./PriceConfig.vue?vue&type=template&id=52304970&scoped=true"
import script from "./PriceConfig.vue?vue&type=script&lang=js"
export * from "./PriceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52304970",
  null
  
)

export default component.exports